@if (stores$ | async; as stores) {
  <nz-divider></nz-divider>
  <nz-spin [nzSpinning]="loading">
    <form nz-form [formGroup]="form" (ngSubmit)="submitForm()">
      <nz-row>
        <nz-col [nzFlex]="12">
          @if (productionOrder) {
            <nz-form-item class="slim">
              <nz-form-label [nzSm]="10" [nzXs]="24">Datum</nz-form-label>
              <nz-form-control [nzSm]="13" [nzXs]="24">
                {{ productionOrder.processingDate|dateFormat }}
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="slim">
              <nz-form-label [nzSm]="10" [nzXs]="24">Artikel</nz-form-label>
              <nz-form-control [nzSm]="13" [nzXs]="24">
                {{productionOrder.article.name}}
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="slim">
              <nz-form-label [nzSm]="10" [nzXs]="24">Lieferant</nz-form-label>
              <nz-form-control [nzSm]="13" [nzXs]="24">
                {{productionOrder.bulkContainer.supplier.name}}
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="slim">
              <nz-form-label [nzSm]="10" [nzXs]="24">Charge</nz-form-label>
              <nz-form-control [nzSm]="13" [nzXs]="24">
                {{productionOrder.bulkContainer.charge}}
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="slim">
              <nz-form-label [nzSm]="10" [nzXs]="24">MHD</nz-form-label>
              <nz-form-control [nzSm]="13" [nzXs]="24">
                {{productionOrder.bulkContainer.mhd | dateFormat}}
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="slim">
              <nz-form-label [nzSm]="10" [nzXs]="24">BIO</nz-form-label>
              <nz-form-control [nzSm]="13" [nzXs]="24">
                {{productionOrder.article.isBio|booleanFormat}}
              </nz-form-control>
            </nz-form-item>
            <nz-form-item class="slim">
              <nz-form-label [nzSm]="10" [nzXs]="24">eigener Produktion:</nz-form-label>
              <nz-form-control [nzSm]="13" [nzXs]="24">
                {{productionOrder.article.isOwnProduction | booleanFormat}}
              </nz-form-control>
            </nz-form-item>
          }
        </nz-col>
        @if (_orderNumber) {
          <nz-col [nzFlex]="12" style="min-height: 50px">
            @if (changeLogs$|async; as changelog;) {
              <nz-table
                #tableRef
                nzShowSizeChanger
                [nzData]="changelog"
                [nzLoading]="loading"
                [nzShowPagination]="false"
                >
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Datum</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  @for (log of changelog; track log) {
                    <tr>
                      <td>{{log.newStatus|statusFormat}}</td>
                      <td>{{log.createdAt|dateFormat}}</td>
                      <td>{{log.worker.fullName}}</td>
                    </tr>
                  }
                </tbody>
              </nz-table>
            }
            <ng-template #changeLogLoader>
              <nz-spin [nzSpinning]="true" style="min-height: 50px"></nz-spin>
            </ng-template>
          </nz-col>
        }
      </nz-row>
      <nz-divider></nz-divider>
      <nz-row>
        <nz-col nzFlex="24">
          <nz-table
            #tableRef
            nzShowSizeChanger
            [nzData]="variants"
            [nzLoading]="loading"
            [nzShowPagination]="false"
            >
            <thead>
              <tr>
                <th>Variante</th>
                <th>EAN</th>
                <th>Gewicht</th>
                <th>Anzahl</th>
                <th>Gescannt</th>
                @if (productionOrder && currentStatus === statuses.Posted) {
                  <th>Lager</th>
                }
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (variant of variants; track variant) {
                <tr
                  [class]="(variant.scanned >= variant.quantity || variant.isCorrected ? 'finished':'')"
                  (dblclick)="variant.scanned = variant.quantity"
                  style="cursor:pointer;"
                  >
                  <td>{{ variant.articleVariant.name }}{{ variant.recipeCardVariant ? ' (' + variant.recipeCardVariant.value + ')' : '' }}</td>
                  <td>{{variant.articleVariant.ean}}</td>
                  <td>{{ variant.articleVariant.customWeight ? (variant.articleVariant.customWeight + ' g') : (variant.articleVariant.purchaseUnit | unitFormat:'kg') }}</td>
                  <td>{{variant.quantity}}</td>
                  <td>{{variant.scanned}}</td>
                  @if (productionOrder && currentStatus === statuses.Posted) {
                    <td>{{variant.targetStoreId | storeNameById:stores}}</td>
                  }
                  <td>
                    <div class="actions">
                      @if (currentStatus === statuses.Created) {
                        <span>
                          <i
                            nz-icon
                            nzType="edit"
                            nzTheme="outline"
                            (click)="openCorrectModal(variant)"
                            nz-tooltip
                            nzTooltipTitle="Variante korrigieren"
                          ></i>
                        </span>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </nz-col>
      </nz-row>
    </form>
    @if (currentStatus !== statuses.Posted) {
      <div class="ean-scanner--container">
        <span>Das Produkt scannen: </span><input [(ngModel)]="currentEan" (ngModelChange)="handleEanScan($event)" [ngModelOptions]="{standalone: true}" #eanField>
      </div>
    }
  </nz-spin>
  @if (productionOrder && currentStatus === statuses.Created) {
    <nz-modal
      [nzMaskClosable]="false"
      [(nzVisible)]="correctModalVisible"
      [nzTitle]="correctModalTitle"
      [nzContent]="correctModalContent"
      [nzFooter]="correctModalFooter"
      [nzWidth]="300"
      (nzOnCancel)="correctModal.close()"
      #correctModal
      >
      <ng-template #correctModalTitle>{{ correctModalHeading }}</ng-template>
      <ng-template #correctModalContent>
        <span>Neuer Wert: </span><input [(ngModel)]="newVariantValue">
      </ng-template>
      <ng-template #correctModalFooter>
        <button nz-button nzType="default" (click)="correctModal.close()">Schließen</button>
        <button nz-button nzType="primary" (click)="correctVariant()">Speichern</button>
      </ng-template>
    </nz-modal>
  }
  @if (productionOrder && currentStatus === statuses.Labeled) {
    <nz-modal
      [nzMaskClosable]="false"
      [(nzVisible)]="insertModalVisible"
      [nzTitle]="insertModalTitle"
      [nzContent]="insertModalContent"
      [nzFooter]="insertModalFooter"
      [nzWidth]="1000"
      (nzOnCancel)="insertModal.close()"
      (nzAfterClose)="resetVariantsStocks()"
      #insertModal
      >
      <ng-template #insertModalTitle>Menge einbuchen: {{ productionOrder.article.name }}</ng-template>
      <ng-template #insertModalContent>
        @if (isBookFormDisabled) {
          <nz-alert nzType="error" nzMessage="Die linke Menge muss gleich 0 sein."></nz-alert>
        }
        <nz-table
          #tableRef
          nzShowSizeChanger
          [nzData]="variants"
          [nzLoading]="loading"
          [nzShowPagination]="false"
          >
          <thead>
            <tr>
              <th>Variante</th>
              <th>Gesamtmenge</th>
              <th>links Menge zuordnen</th>
              @for (store of stores; track store) {
                @if (store | isStoreMainOrBbm) {
                  <th>
                    {{ store.value }}
                  </th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (variant of variants; track variant) {
              <tr>
                <td>{{variant.articleVariant.name}}</td>
                <td>{{variant.quantity}}</td>
                <td>{{variant.leftQuantity}}</td>
                @for (store of stores; track store) {
                  @if (store | isStoreMainOrBbm) {
                    <td>
                      <input
                        nz-input
                        type="number"
                        [(ngModel)]="variant['Stock' + store.id]"
                        (ngModelChange)="handleStockChange(variant, store)"
                        />
                    </td>
                  }
                }
              </tr>
            }
          </tbody>
        </nz-table>
      </ng-template>
      <ng-template #insertModalFooter>
        <button nz-button nzType="default" (click)="insertModal.close()">Schließen</button>
        <button
          nz-button
          [nzLoading]="loading"
          nzType="primary"
          (click)="submitForm()"
          [disabled]="isBookFormDisabled"
        >Speichern</button>
      </ng-template>
    </nz-modal>
  }
}
